import { bindable, bindingMode, computedFrom } from 'aurelia-framework';

export class DatePicker {
	@bindable({ defaultBindingMode: bindingMode.twoWay }) disabled: boolean = false;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) selectedDate: string;;
	@bindable({ defaultBindingMode: bindingMode.twoWay }) label?: string = 'Date';
	@bindable({ defaultBindingMode: bindingMode.twoWay }) controlId: string;

	constructor() {

	}

	changed() {
		this.selectedDate = (<HTMLInputElement>document.getElementById(this.controlId + 'dp')).value;
	}
}